import { create } from "zustand";

// POC consumer identity. Real impl reads from LS-SPEC-25 IAM session
// cookie after the consumer authenticates with their wallet host. For
// the first cut we hard-bind to the POC default consumer the wallet
// adapter + Twin pre-seed in the dev runtime.

export const POC_DEFAULT_CONSUMER_ID = "poc_default_consumer";

interface AuthState {
  consumerId: string;
  displayName: string;
  // Phase 2: capabilityToken from IAM; for now Aide mints its own root
  // capability per session.
  setConsumer: (consumerId: string, displayName: string) => void;
}

export const useAuth = create<AuthState>((set) => ({
  consumerId: POC_DEFAULT_CONSUMER_ID,
  displayName: "You",
  setConsumer: (consumerId, displayName) => set({ consumerId, displayName }),
}));
